import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`).catch((error) => {
      console.error('Service worker registration failed:', error);
    });
  });
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
